import { convertToVector3 } from "./vector3.js";

const vector = {
  convertToVector3
};

export default vector;
